import { Breakpoint, Color, Shape, Typography } from '@elearning-platform/ui';
import { styled } from 'styled-components';

import { AppZIndex } from '../../../../../enums';

export const Wrapper = styled.div`
  width: 100%;
  background-color: ${Color.Black100};
  position: relative;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  padding: 100px 16px;

  @media ${Breakpoint.SmallDesktop} {
    padding: 100px 80px;
  }
`;

export const TextContainer = styled.div`
  max-width: 620px;

  @media ${Breakpoint.DesktopXL} {
    max-width: 754px;
  }
`;

export const Image = styled.img`
  width: 100%;
`;

export const StyledModule = styled(Typography)`
  color: ${Color.Brand100};
`;

export const StyledTitle = styled(Typography)`
  color: ${Color.White};
`;

export const StyledShape = styled(Shape)`
  position: absolute;
  top: 226px;
  right: 16px;
  width: 112px;
  height: 150px;
  z-index: ${AppZIndex.Min};

  @media ${Breakpoint.SmallDesktop} {
    width: 180px;
    height: 326px;
    top: 150px;
    right: 30px;
  }
`;
